import { useTranslation } from 'react-i18next'

import { isRussia } from 'env'
import useFormatDate from 'hooks/useFormatDate'
import { Company } from 'modules/domain/company/types'
import { getPersonalNumberLabel } from 'modules/utils/numbers/formatPersonalNumber'
import { FC } from 'react'
import { CompanySizeTag } from 'views/pages/User/UserDetail/CompanySizeTag'
import * as Header from 'views/ui/Header/Header'

type Props = {
  company: Company
}

export const CompanySubtitle: FC<Props> = (props) => {
  const { company } = props
  const { t } = useTranslation('company')
  const formatDate = useFormatDate()

  const inn = `${getPersonalNumberLabel()}: ${company.inn || t('common:notSpecified')}`

  const date = `${t('form.fields.created')}: ${formatDate(company.created, { withTime: true })}`

  return (
    <Header.SubTitle>
      <Header.InlineContainer>
        {isRussia && <CompanySizeTag companySize={company.company_size} />}
        {[inn, date].filter(Boolean).join(' / ')}
      </Header.InlineContainer>
    </Header.SubTitle>
  )
}
